import { render, staticRenderFns } from "./tableItems.vue?vue&type=template&id=5b107804"
import script from "./tableItems.vue?vue&type=script&lang=js"
export * from "./tableItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports